<div class="padding flex column fix-height">
	<b class="margin-bottom-small flex between">
		{{ data.title }}
	</b>

	<div class="flex column gap-small">
		<div class="flex center">
			<input type="text" class="flex-1" [(ngModel)]="texts" />
		</div>
	</div>

	<div class="flex column end margin-top-small">
		<div class="flex center">
			<button class="stroked margin-right-small" (click)="onClose()">
				<mat-icon class="small margin-right-smallest">undo</mat-icon>
				Discard
			</button>
			<button (click)="apply()" cdkFocusInitial>
				<mat-icon class="small margin-right-smallest">check</mat-icon>
				Apply
			</button>
		</div>
	</div>
</div>
